import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const mapToCSSModule = (classes, theme) => {
  return classNames(Array.isArray(classes) ? classes.map(c => theme[c]) : theme[classes])
}

const Card = props => {
  const { header, skipHeader, footer, color, theme, children, classes, ...attributes } = props
  return (
    <div className={mapToCSSModule(['card', color, ...classes], theme)} {...attributes}>
      <If condition={header}>
        <div className={theme['card-header']}>{header}</div>
      </If>
      <If condition={children}>
        <div
          className={classNames(theme['card-body'], {
            [theme['with-header']]: header && skipHeader !== true,
            [theme['without-header']]: !header && skipHeader !== true,
          })}
        >
          {children}
        </div>
      </If>
      <If condition={footer}>
        <div className={theme['card-footer']}>{footer}</div>
      </If>
    </div>
  )
}

Card.propTypes = {
  theme: PropTypes.object.isRequired,
}

Card.defaultProps = {
  theme: {},
}

export default Card



// WEBPACK FOOTER //
// ./ui/Card/Card.js